export function formatLayoutNumber(number: number) {
  return parseFloat(number.toFixed(3));
}
